module.exports = __webpack_public_path__ + "img/testing-chemi.24f295d8.svg";